import {
  styled as muiStyled,
  Grid,
  Button,
  Typography,
  Stack,
} from '@mui/material';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

const Line = muiStyled(Grid)({
  background: NEW_COLORS.BASE.WHITE,
  padding: '16px',
  borderRadius: '4px',
  border: `1px solid ${NEW_COLORS.GRAYSCALE[200]}`,
});

const StyledGrid = muiStyled(Grid)({
  display: 'flex',
  alignItems: 'flex-end',
  flexDirection: 'column',
});

const ActionButton = muiStyled(Button)(() => ({
  borderRadius: '4px',
  height: '53px',
  fontWeight: 600,
  '& .MuiButton-endIcon': {
    marginLeft: 0,
  },
}));
export const Label = muiStyled(Typography)(() => ({
  '&.MuiTypography-root': {
    color: NEW_COLORS.GRAYSCALE[700],
  },
}));

export const StyledStack = muiStyled(Stack)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column-reverse',
  },
}));

export { ActionButton, StyledGrid, Line };
